import { LogoMark } from "@/components/app/Brand";

/**
 * Floating "Powered by CombinedWork" badge for public/marketing surfaces.
 * Mirrors the dimensions of the platform-injected badge but uses the
 * CombinedWork brand mark and routes to /pricing#demo as a soft CTA.
 *
 * - Hidden by default inside the authenticated app (would be redundant).
 * - Click target opens in a new tab if a `href` prop is supplied — otherwise
 *   defaults to the in-app pricing page where a "Book a demo" CTA lives.
 */
const PoweredByBadge = ({
  href = "/pricing#demo",
  label = "Powered by CombinedWork",
  cta = "Book a demo",
}) => {
  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
      className="group fixed bottom-4 right-4 z-50 flex items-center gap-2.5 bg-gray-900 hover:bg-[#002FA7] text-white pl-2.5 pr-3.5 py-2 transition-colors shadow-lg ring-1 ring-black/10"
      style={{ borderRadius: 999 }}
      data-testid="powered-by-badge"
      aria-label={`${label} — ${cta}`}
    >
      <span className="bg-[#0D1117] grid place-items-center w-6 h-6 rounded-full shrink-0">
        <LogoMark size={16} />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[9px] uppercase tracking-[0.18em] text-gray-300 group-hover:text-blue-100">
          Powered by
        </span>
        <span className="text-[13px] font-semibold">
          CombinedWork<span className="hidden sm:inline text-gray-300 group-hover:text-blue-100 font-normal"> · {cta} ↗</span>
        </span>
      </span>
    </a>
  );
};

export default PoweredByBadge;
